import React from 'react';
import { Link } from 'react-router-dom';
import MaterialIcon from './MaterialIcon';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="celestial-footer">
      <div className="celestial-container">
        <div className="celestial-footer__grid">
          <div className="celestial-footer__col">
            <Link to="/" className="celestial-footer__brand">
              <MaterialIcon name="auto_awesome" filled size={20} />
              {' '}
              Astro Social
            </Link>
            <p className="celestial-caption" style={{ marginTop: '1rem', textTransform: 'none' }}>
              © {year} Astro Social. Tüm hakları saklıdır.
            </p>
          </div>
          <div className="celestial-footer__col">
            <h4>Platform</h4>
            <Link to="/icerikler">İçerikler</Link>
            <a href="mailto:support@astroai.work">Destek</a>
          </div>
          <div className="celestial-footer__col">
            <h4>Yasal</h4>
            <Link to="/privacy">Gizlilik</Link>
            <Link to="/terms">Kullanım Koşulları</Link>
            <Link to="/child-safety">Çocuk Güvenliği</Link>
          </div>
          <div className="celestial-footer__col">
            <h4>Hesap</h4>
            <Link to="/hesap-sil">Hesap Silme</Link>
            <Link to="/giris">Giriş</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
